<script setup lang="ts">
import { ref, watch } from 'vue'
import { useColorMode } from '@/composables/src/useColorMode'

const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  value: {
    type: Object,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  emptyMessage: {
    type: String,
    default: 'No results found.',
  },
  placeholder: {
    type: String,
    default: '',
  },
  insideText: {
    type: String,
    default: '',
  },
  defaultOption: {
    type: String,
    default: null,
  },
  padding: {
    type: String,
    default: '',
  },
  height: {
    type: Number,
    default: 40,
  },
  showLogo: {
    type: Boolean,
    default: false,
  },
  showSpace: {
    type: Boolean,
    default: false,
  },
})

const time = ref({
  hours: props.value?.hours ?? 0,
  minutes: props.value?.minutes ?? 0,
})
const { mode } = useColorMode()

const emit = defineEmits(['update:value'])

watch(
  time,
  (val) => {
    emit('update:value', val)
  },
  { deep: true, immediate: true },
)

const maxHour = 99
const maxMinute = 59

const hourOptions = Array.from({ length: maxHour + 1 }, (_, i) => i)
const minuteOptions = Array.from({ length: maxMinute + 1 }, (_, i) => i)
</script>

<template>
  <div
    class="flex items-center justify-start gap-4 rounded-full x-4 py-2 px-1 border border-border border-solid shadow-sm"
    :class="{
      'bg-sidebar-accent': mode === 'dark',
      'bg-white': mode === 'light',
    }"
    :style="{ height: props.height + 'px', padding: props.padding }"
  >
    <div class="flex items-center gap-2">
      <div class="flex items-center gap-1">
        <select
          v-model.number="time.hours"
          :disabled="props.disabled"
          class="shadcn-select text-center w-16 py-1 text-base font-thin border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary transition bg-background hover:border-primary cursor-pointer font-[Arial,sans-serif]"
          :class="{
            'bg-[#303540]': mode === 'dark',
            'bg-white': mode === 'light',
          }"
        >
          <option v-for="h in hourOptions" :key="h" :value="h">{{ h.toString().padStart(2, '0') }}</option>
        </select>
      </div>
      <span class="text-xl font-bold text-muted-foreground">:</span>
      <div class="flex items-center gap-1">
        <select
          v-model.number="time.minutes"
          :disabled="props.disabled"
          class="shadcn-select text-center w-16 py-1 text-base font-thin border border-input rounded-lg focus:outline-none focus:ring-2 focus:ring-primary transition bg-background hover:border-primary cursor-pointer font-[Arial,sans-serif]"
          :class="{
            'bg-[#303540]': mode === 'dark',
            'bg-white': mode === 'light',
          }"
        >
          <option v-for="m in minuteOptions" :key="m" :value="m">{{ m.toString().padStart(2, '0') }}</option>
        </select>
      </div>
    </div>
  </div>
</template>
